import React from "react";
import ottawaImg from "../../../assets/image/brampton4.jpg"; // apni image lagana

const ImmigrationMap = () => {
  return (
    <section className="pt-10 md:pt-20">
      <div className="max-w-7xl mx-auto px-4">

        {/* CONTENT TEXT */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-16">
          <div>
            <p className="uppercase tracking-widest font-semibold text-[#777777]">
              How We Support Clients
            </p>
            <h2 className="text-3xl md:text-5xl font-bold text-black my-6">
              Facing immigration <br /> concerns?
            </h2>
            <div className="flex gap-2 items-center">
              <div className="w-12 h-1 bg-[#ec4e4f] "></div>
              <div className="w-1 h-1 bg-[#ec4e4f]"></div>
              <div className="w-1 h-1 bg-[#ec4e4f]"></div>
              <div className="w-1 h-1 bg-[#ec4e4f]"></div>
            </div>
          </div>

          <p className="text-xl md:text-2xl text-[#555555] leading-relaxed">
            We are always ready to assist our clients with any challenges, providing prompt, professional, and
            dependable support at every step.
          </p>
        </div>


        {/* 🔥 FLIP CARD */}
        <div className="group relative w-full h-[360px] [perspective:1200px]">
          <div className="relative w-full h-full transition-transform duration-700 [transform-style:preserve-3d] group-hover:[transform:rotatex(180deg)]">

            {/* FRONT – DEFAULT IMAGE */}
            <div className="absolute inset-0 rounded-xl overflow-hidden [backface-visibility:hidden]">
              <img
                src={ottawaImg}
                className="w-full h-full object-cover"
                alt="Ottawa"
              />
              <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                <h2 className="text-3xl text-white font-bold">Ottawa Branch</h2>
              </div>
            </div>

            {/* BACK – DETAILS + MAP */}
            <div className="absolute inset-0 rounded-xl text-white [backface-visibility:hidden] [transform:rotatex(180deg)] overflow-hidden">

              {/* Background */}
              <div className="absolute inset-0 bg-[#162e40]"></div>

              {/* CONTENT */}
              <div className="relative z-10 h-full group/back p-6 transition-all duration-500">

                <h3 className="text-2xl font-bold mb-3">Ottawa Branch</h3>

                <ul className="text-md space-y-2 text-gray-200">
                  <li>
                    <strong className="text-white">Address:</strong><br />
                    209-1390 Prince of Wales Dr, Ottawa, ON, K2C 3N6
                  </li>
                  <li>
                    <strong className="text-white">Contact:</strong> +1 (438) 927-2958
                  </li>
                  <li>
                    <strong className="text-white">Email:</strong> info@trinitymanagementservices.ca
                  </li>
                </ul>

                {/* MAP – only when back side hovered */}
                {/* MAP – Half on flip, Full on map hover */}
                <div
                  className="
      absolute bottom-0 left-0 w-full
      h-1/2
      translate-y-full
      transition-all duration-700 ease-in-out
      group-hover:translate-y-0
      group-hover-within:translate-y-0
      hover:h-full
      hover:translate-y-0
      z-20
    "
                >
                  <iframe
                    title="Ottawa Office Location"
                    src="https://www.google.com/maps?q=209-1390+Prince+of+Wales+Dr,+Ottawa,+ON,+K2C+3N6&output=embed"
                    className="w-full h-full border-0"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>


              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default ImmigrationMap;
